import { NavLink } from "react-router-dom";
import { cockpitComponent } from "../../components/CockpitLayoutComponents";
import { useMediaQuery } from "react-responsive";
import { useCallback, useRef, useState } from "react";
import GenericFlyout from "../../components/modal/GenericFlyout";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";

const LogoMenu = ({ content }) => {
  const btnRef = useRef();
  const isSmall = useMediaQuery({ maxWidth: 767.98 });
  const t = useBjelinTranslations();

  const [showMenu, setShowMenu] = useState(false);
  const toggleMenu = useCallback(() => setShowMenu(showMenu => !showMenu), []);
  const closeMenu = useCallback(() => setShowMenu(false), []);

  return (
    <>
      <NavLink
        ref={btnRef}
        to="/"
        exact={true}
        style={{ padding: "5px" }}
        onContextMenu={e => {
          if (content) {
            if (!showMenu) e.preventDefault();
            toggleMenu();
          }
        }}
        onClick={e => {
          if (showMenu) e.preventDefault();
        }}
        title={t("link.frontpage")}
      >
        <svg viewBox="0 0 139 35" alt="logo" style={{ width: "100%" }}>
          <g fill="#fff">
            <path d="M0 0 12.743 0C15.975.031 18.403.87 20.027 2.514 21.666 4.176 22.485 6.371 22.485 9.103 22.516 10.5 22.193 11.835 21.516 13.108 21.17 13.713 20.674 14.287 20.028 14.83 19.382 15.405 18.585 15.925 17.639 16.39L17.639 16.483C19.432 16.965 20.789 17.935 21.709 19.394 22.568 20.899 22.998 22.537 22.998 24.306 22.967 27.239 22.08 29.56 20.335 31.267 18.604 33.052 16.445 33.944 13.857 33.944L0 33.944 0 0ZM4.978 4.561 4.978 14.32 12.177 14.32C13.998 14.32 15.337 13.829 16.194 12.846 17.067 11.941 17.503 10.802 17.503 9.429 17.503 8.056 17.067 6.894 16.194 5.942 15.337 5.053 13.998 4.592 12.177 4.561L4.978 4.561ZM4.978 18.879 4.978 29.104 12.663 29.104C14.516 29.073 15.873 28.552 16.731 27.54 17.59 26.544 18.02 25.361 18.02 23.992 18.02 22.591 17.59 21.392 16.731 20.396 15.873 19.416 14.516 18.91 12.663 18.879L4.978 18.879ZM28.8526 26.8183C29.3186 27.4563 29.9206 27.9773 30.6576 28.3813 31.3946 28.8633 32.2586 29.1043 33.2516 29.1043 34.5726 29.1353 35.8326 28.6613 37.0336 27.6823 37.6176 27.2013 38.0756 26.5643 38.4066 25.7723 38.7506 25.0103 38.9236 24.0553 38.9236 22.9053L38.9236.0003 43.9016.0003 43.9016 23.3983C43.8416 26.8133 42.7606 29.4513 40.6596 31.3133 38.5726 33.2223 36.1486 34.1923 33.3876 34.2233 29.5416 34.1313 26.6486 32.6633 24.7086 29.8223L28.8526 26.8183Z" />
            <polygon points="76.155 0 81.133 0 81.133 29.104 97.159 29.104 97.159 33.944 76.155 33.944" />
            <polygon points="101.934 33.944 106.912 33.944 106.912 0 101.934 0" />
            <polygon points="113.44 0 118.133 0 133.022 24.131 133.112 24.131 133.112 0 138.09 0 138.09 33.944 133.375 33.944 118.507 9.813 118.418 9.813 118.418 33.944 113.44 33.944" />
            <polygon points="60.368 19.252 69.196 19.252 69.196 14.693 60.368 14.693" />
            <polygon points="71.417 0 50.413 0 50.413 33.944 71.417 33.944 71.417 29.104 55.391 29.104 55.391 4.841 71.417 4.841" />
          </g>
        </svg>
      </NavLink>
      {content && (
        <GenericFlyout
          id={"logo-dropdown"}
          isOpen={showMenu}
          close={closeMenu}
          noCloseBtn
          align={"top-left"}
          isMobileSubMenu
          width={20}
        >
          <div
            className={"mega-menu-content"}
            style={{
              width: "100%",
              height: isSmall ? "100%" : "fit-content",
              maxHeight: `calc(100vh - var(--safe-area-inset-top) - var(--safe-area-inset-bottom) - var(--menu-height) - var(--padding-top))`,
              background: "#fff"
            }}
          >
            {content.map(cockpitComponent)}
          </div>
        </GenericFlyout>
      )}
    </>
  );
};

export default LogoMenu;
